import { ReactNode, createContext, useContext } from "react";

import { User } from "firebase/auth";
import { useAuth } from "./AuthProvider";
import { AuthWidget } from "./AuthWidget";

type ContextInfo = {
  user: User;
};

export const UserContext = createContext<ContextInfo>({} as any);

type Props = { children: ReactNode };

const UserProvider = (props: Props) => {
  //
  const { user } = useAuth();
  // login
  if (!user || !user.emailVerified) {
    return <AuthWidget />;
  }

  return <UserContext.Provider value={{ user }}>{props.children}</UserContext.Provider>;
};

function useUser() {
  return useContext(UserContext);
}

export { UserProvider, useUser };
